export function getBaseURL(baseURL) {
  if (baseURL) {
    return baseURL;
  }

  if (typeof(window) !== 'undefined') {
    return window.location;
  }

  return undefined;
}
